export enum VoucherStatusEnum {
  CLOSING_BEFORE = '1',
  CLOSING_AFTER = '2',
}

export const VoucherStatus = [
  { label: '締切前', value: VoucherStatusEnum.CLOSING_BEFORE },
  { label: '締切済', value: VoucherStatusEnum.CLOSING_AFTER },
];
